import { render, staticRenderFns } from "./CommunityBusinessnewsReply.vue?vue&type=template&id=24e53c48"
import script from "./CommunityBusinessnewsReply.vue?vue&type=script&lang=js"
export * from "./CommunityBusinessnewsReply.vue?vue&type=script&lang=js"
import style0 from "./CommunityBusinessnewsReply.vue?vue&type=style&index=0&id=24e53c48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports